<script>
import BaseDropdown from './BaseDropdown';

export default {
  name: 'question-holiday-home-location',
  extends: BaseDropdown,
  props: {
    // key - payload key
    // value - field from stepData which should be set as value for payload
    payloadFields: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      fields: ['field'],
      options: [],
      searchPayload: {},
    };
  },
  created () {
    this.setSearchPayload();

    if (Object.keys(this.searchPayload).length) {
      this.onSearch();
    }

    Object.keys(this.payloadFields).forEach((key) => {
      this.$watch(() => this.stepData[this.payloadFields[key]], () => {
        this.questionData[this.questionFields.field] = null;
        this.fieldOptions = [];
        this.setSearchPayload();

        this.onSearch();
      });
    });
  },
  methods: {
    setSearchPayload () {
      Object.keys(this.payloadFields).forEach((key) => {
        this.searchPayload[key] = this.stepData[this.payloadFields[key]];
      });
    },
    async onSearch () {
      try {
        if (!Object.keys(this.searchPayload).length || Object.values(this.searchPayload).includes(null)) return;

        const response = await this.$api[this.searchType](this.searchPayload);

        if (response.status === 'success') {
          if (Array.isArray(response.data)) {
            this.fieldOptions = response.data.map(item => ({
              value: item.value,
              text: item.name,
            }));

            return;
          }

          this.fieldOptions = Object.keys(response.data).reduce((acc, item) => {
            const options = Object.values(response.data[item]).map(option => (
              {
                value: option.value,
                text: option.name,
              }
            ));

            if (item === 'Other') return options;

            return [...acc, { header: item }, ...options];
          }, []);
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
